module.exports = {

  title: '转链工具',

  /**
   * @type {boolean} true | false
   * @description 是否固定头部
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description 是否显示设置
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description 是否显示侧边栏logo
   */
  sidebarLogo: true,

  /**
  * @type {boolean} true | false
  * @description Whether show the logo in sidebar
  */
  tagsView: true,
  /**
   * @type {string} 
   * @description 默认主题色
   */
  defaultTheme: '#056de8'
}
